import React, { useRef, useEffect } from 'react';
import IntlTelInput from "intl-tel-input/react";
import "intl-tel-input/styles";
import { PhoneNumberInputContainer } from './style';

const PhoneNumberInput = ({
  width,
  title,
  mainPage,
  required,
  additionalstyle,
  marginBottom,
  disabled,
  placeholder,
  onBlur,
  value,
  onChangeNumber,
  onPhoneValidityChange,
  error,
  errorMessage
}) => {

  const itiRef = useRef(null);

  useEffect(() => {
    if (itiRef.current && value) {
      const instance = itiRef.current.getInstance();
      instance.setNumber(value);
    }
  }, [value]);

  return (
    <PhoneNumberInputContainer
      mainPage={mainPage}
      additionalstyle={additionalstyle}
      error={error}
      disabled={disabled}
      width={width}
      marginBottom={marginBottom}
    >
      {title && <div className='label'>
        {title}
        {required? <span className='warning'> *</span>: null}
      </div>}
      <IntlTelInput
        ref={itiRef}
        value={value}
        initOptions={{ 
          initialCountry: 'ca',
          formatOnDisplay: true,
          nationalMode: true,
          autoPlaceholder: 'off',
          utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.0.10/build/js/utils.js"
        }}
        inputProps={{
          disabled: disabled,
          placeholder: placeholder,
          onBlur: onBlur,
        }}
        onChangeNumber={onChangeNumber}
        onChangeValidity={onPhoneValidityChange}
      />
      {error? <div className="warning">{errorMessage? errorMessage:'Please enter a valid phone number'}</div>: null}
    </PhoneNumberInputContainer>
  )
}

export default PhoneNumberInput;
